import { initStore } from '@/store'
import { useRouter } from 'next/router'
import { Language } from './enums/language'

/**
 * @description --language--------
 */
export const useCurrentLanguage = () => {
  const router = useRouter()
  const language = Language[initStore().ConfigStore.language]
  let lng = router?.locale === language ? language : router.locale || language
  // Next.js i18n uses en-us; resource bundles and comparisons use en
  if (lng === 'en-us') {
    lng = Language.EN
  }
  return {
    language: lng,
  }
}

export const getLanguageFromParams = () => {
  const router = useRouter()
  const { lang } = router.query
  if (lang && Object.values(Language).includes(lang as Language)) {
    return lang as Language
  }
  return Language.ID // default to ID if not found
}
